import { useEffect, useRef, useState } from "react";

export const SceneVideo = ({
  src,
  poster,
  posterMobile,
  className = "",
  eager = false,
  children,
  testId,
  alt = "",
}) => {
  const wrapRef = useRef(null);
  const videoRef = useRef(null);
  const [loadVideo, setLoadVideo] = useState(eager);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoadVideo(true);
          if (videoRef.current) {
            videoRef.current.play().catch(() => {});
          }
        } else if (videoRef.current) {
          videoRef.current.pause();
        }
      },
      { rootMargin: "300px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={wrapRef}
      className={`relative overflow-hidden ${className}`}
      data-testid={testId}
    >
      <picture>
        {posterMobile && (
          <source media="(max-width: 640px)" srcSet={posterMobile} />
        )}
        <img
          src={poster}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover"
          loading={eager ? "eager" : "lazy"}
        />
      </picture>
      {loadVideo && (
        <video
          ref={videoRef}
          src={src}
          poster={poster}
          className="absolute inset-0 h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload={eager ? "auto" : "metadata"}
        />
      )}
      {children}
    </div>
  );
};
